/** @jsx jsx */
import { jsx } from '@emotion/react';
import {
  LabeledBooleanInput,
  Props as LabeledBooleanInputProps,
} from './LabeledBooleanInput';

type Props = Omit<LabeledBooleanInputProps, 'type'> & {
  /**
   * The content to render for the label
   */
  children: React.ReactNode;

  /**
   * Indicates whether `LabeledRadio` is disabled.
   * @deprecated Use `isDisabled` instead
   */
  disabled?: boolean;
};

export const LabeledRadio = ({ disabled, isDisabled, ...props }: Props) => (
  <LabeledBooleanInput
    {...props}
    isDisabled={disabled || isDisabled}
    type="radio"
  />
);
